<script>
  export const location = false;
  export let params;

  console.log(`[*] params: ${JSON.stringify(params)}`);

  let agree = false;

  const next = () => {
    window.location = "/payment";
  };
</script>

<div class="container">
  <div class="header">Pricing Agreement</div>
  <div class="notice">
    <strong>Notice:</strong> We will temporarily authorize a $25 charge to cover
    your session. You will only be charged for the actual amount used based on the
    rates shown below.
  </div>

  <div class="price-details">
    <p>Cost per Hour: <span>$5.00</span></p>
    <p>Cost per Session: <span>$25.00</span></p>
    <p>Cost per kWh: <span>$0.12</span></p>
  </div>

  <div class="agreement">
    <input type="checkbox" bind:checked={agree} />
    <label for="agree"> I agree to the pricing terms. </label>
  </div>

  <button class="submit-button" disabled={!agree} on:click={next}>
    Agree &amp; Continue
  </button>
</div>
